import React, { forwardRef } from 'react';
import MuiBox, { BoxProps as MuiBoxProps } from '@mui/material/Box';
import { BpDesignSystem } from '../../types';

export type BoxProps = BpDesignSystem.PropsWithChildren<MuiBoxProps & {}>;

export const Box = forwardRef<HTMLElement, BoxProps>(({ dataTest, sx, ...props }, ref) => (
  <MuiBox ref={ref} data-test={dataTest} sx={sx} {...props} />
));
